// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2022 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { ClickablePresentationProps } from "@insite/mobius/Clickable";
import Icon, { IconPresentationProps } from "@insite/mobius/Icon/Icon";
import { TypographyPresentationProps } from "@insite/mobius/Typography/Typography";
import getColor from "@insite/mobius/utilities/getColor";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import { RugPopupStyleInterface } from "@rugby/App/Components/Tippy/Interface";
import { rugPopupStyles } from "@rugby/App/Components/Tippy/Style";
import { screen } from "@rugby/XDL/Helpers";
import { color, MediaQuery } from "@rugby/XDL/Utilities";
import { css } from "styled-components";

interface HeaderSignInStyles {
    signOutWrapper?: InjectableCss;
    titleClickable?: ClickablePresentationProps;
    titleIcon?: IconPresentationProps;
    titleTypography?: TypographyPresentationProps;
    signOutClickable?: ClickablePresentationProps;
    userIcon?: IconPresentationProps;
    signInText?: InjectableCss;
    registerText?: InjectableCss;
    textWrapper?: InjectableCss;
    signInLink?: InjectableCss;
    tippyStyle?: RugPopupStyleInterface;
}

export const headerSignInStyles: HeaderSignInStyles = {
    signOutWrapper: {
        css: css`
            display: inline-flex;
        `,
    },
    titleClickable: {
        css: css`
            margin-left: 10px;
        `,
    },
    titleIcon: {
        size: 22,
    },
    titleTypography: {
        css: css`
            margin-left: 10px;
            max-width: 150px;
        `,
        ellipsis: true,
        transform: "uppercase",
    },
    signOutClickable: {
        css: css`
            flex: 0 0 auto;
            margin-left: 30px;
            text-transform: uppercase;
        `,
    },

    userIcon: {
        css: css`
            background-color: ${({ isActive }: any) =>
                isActive ? getColor("secondary.main") : getColor("common.brand3")};
            height: 30px;
            width: 30px;
            border-radius: 3px;
            padding: 4px;
            color: ${getColor("common.white")};
            margin-right: 8px;

            ${screen("lte", "sm")`
               height: 40px;
               width: 40px;
               z-index: 1;

               svg {
                height: 40px;
                width: 40px;
               }
            `}
        `,
    },
    textWrapper: {
        css: css`
            display: flex;
            flex-direction: column;
            max-width: 60px;
        `,
    },
    signInText: {
        css: css`
            color: ${color("text.main")};
            font-size: 13px;
            font-weight: bold;
            text-transform: capitalize;
            letter-spacing: 0;
            line-height: 17px;
        `,
    },
    registerText: {
        css: css`
            color: ${color("text.main")};
            font-size: 13px;
            text-transform: capitalize;
            letter-spacing: 0;
            line-height: 17px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
        `,
    },
    signInLink: {
        css: css`
            margin-bottom: 5px;
            &:focus {
                outline: none;
            }
            & > span {
                display: flex;
                flex-direction: row;
                align-items: flex-end;
                cursor: pointer;
                max-width: 100px;
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
            }

            &:hover svg,
            &:hover > span > span {
                background-color: ${color("secondary")};
            }
        `,
    },
    tippyStyle: {
        closeButton: {
            ...rugPopupStyles.closeButton,
            css: css`
                ${rugPopupStyles.closeButton.css}
                top: 8px;

                ${MediaQuery.lte("md")} {
                    color: ${color("common.white")};
                }
            `,
        },
    },
};
